export default [
  {
    check: false,
    title: "일반관리사항",
    list: [
      {
        rowspan: [6, 1],
        content: ["기구조직<br/>① 안전보건기구조직구성여부<br/>② 비상연락망 조직여부", "안전보건관리책임자 선임여부 (100인 이상)"],
        isChecked: "",
      },
      {
        content: ["", "안전관리자 선임(대행계약) 여부 (50인이상)"],
        isChecked: "",
      },
      {
        content: ["", "보건관리자 선임(대행계약) 여부 (50인이상)"],
        isChecked: "",
      },
      {
        content: ["", "관리감독자 지정 여부"],
        isChecked: "",
      },
      {
        content: ["", "현장직원 및 공공기관 비상 연락망 구축 여부"],
        isChecked: "",
      },
      {
        content: ["", "안전보건관리 조직구성 여부"],
        isChecked: "",
      },
      {
        rowspan: [2, 1],
        content: ["산업안전보건위원회<br/>① 구성 및 운영상태", "산업안전보건위원회 구성 및 매분기 1회 이상 정기회의 개최 및 의결 결정사항 이행여부"],
        isChecked: "",
      },
      {
        content: ["", "회의결과 공지 여부"],
        isChecked: "",
      },
      {
        content: ["안전보건관리규정", "안전보건관리규정의 작성여부(100인 이상)"],
        isChecked: "",
      },
      {
        rowspan: [6, 1],
        content: ["안전교육<br/>①신규 채용시 교육<br/>②작업내용 변경시 교육<br/>③특별 안전보건 교육<br/>④정기 안전보건교육<br/>⑤물질안전보건자료 교육", "채용시 8시간 이상 실시 여부"],
        isChecked: "",
      },
      {
        content: ["", "유해·위험작업종사자 16시간 이상 특별교육 실시 여부<br/>(단, 단기간·간헐적 작업의 경우 2시간 이상 실시)"],
        isChecked: "",
      },
      {
        content: ["", "근로자 정기교육 반기 12시간 이상 교육 실시 여부"],
        isChecked: "",
      },
      {
        content: ["", "관리감독자 연 16시간 이상 교육 실시 여부"],
        isChecked: "",
      },
      {
        content: ["", "물질안전보건자료(MSDS)교육 실시 여부"],
        isChecked: "",
      },
      {
        content: ["", "안전보건교육 계획 수립 및 시행 여부"],
        isChecked: "",
      },
      {
        rowspan: [6, 1],
        content: ["각종서류 등<br/>①산업재해 기록.보존<br/>②작업계획서 작성 및 운영상태<br/>③보호구 지급 및 관리<br/>④안전인증 및 안전검사<br/>⑤위험성평가", "산업안전보건법령 요지의 게시 여부　"],
        isChecked: "",
      },
      {
        content: ["", "산업재해 발생 시, 산업재해조사표 작성 여부"],
        isChecked: "",
      },
      {
        content: ["", "작업계획서의 작성 및 준수 여부"],
        isChecked: "",
      },
      {
        content: ["", "보호구 지급대장 및 개인보호구 지급 계획 수립 여부"],
        isChecked: "",
      },
      {
        content: ["", "안전인증 제품 사용 및 안전 검사 합격품 사용 여부"],
        isChecked: "",
      },
      {
        content: ["", "위험성평가 실시 및 교육 여부"],
        isChecked: "",
      },
    ],
  },
  {
    check: false,
    title: "작업장 안전보건",
    list: [
      {
        content: ["작업장 바닥", "작업장 바닥의 미끄럼방지, 정리·정돈 등 현장 관리"],
        isChecked: "",
      },
      {
        rowspan: [2, 1],
        content: ["작업장 통로", "통로표시, 통로상 장애물 유무"],
        isChecked: "",
      },
      {
        content: ["", "가설통로 및 사다리식 통로, 출입구 및 비상구 관리"],
        isChecked: "",
      },
      {
        rowspan: [2, 1],
        content: ["작업발판", "기계·설비 등의 작업발판 설치"],
        isChecked: "",
      },
      {
        content: ["", "비계작업발판 및 이동식 작업발판 등 설치상태"],
        isChecked: "",
      },
      {
        content: ["추락 등의 위험방지", "안전난간 설치 및 개구부 덮개의 설치"],
        isChecked: "",
      },
      {
        content: ["위험기계·기구의 방호조치", "위험기계·기구에 대한 법적인 방호장치 설치상태"],
        isChecked: "",
      },
      {
        content: ["동력기계에 의한 협착 재해예방", "기계·설비의 회전축, 동력전달부 등에 대한 협착 재해예방 조치상태"],
        isChecked: "",
      },
      {
        content: ["차량계 하역운반기계에 의한 재해예방", "지게차, 화물차, 고소작업차 등의 안전대책 (작업계획서 작성·비치 등 포함)"],
        isChecked: "",
      },
      {
        content: ["개인보호구 지급·착용", "적절한 보호구 지급·사용 및 예비품 비치 등의 관리"],
        isChecked: "",
      },
      {
        content: ["안전보건표지판 설치", "근로자에게 유해·위험한 장소임을 알리고 안전의식 고취를 위한 경고, 안내 등의 안전보건표지판 설치"],
        isChecked: "",
      },
      {
        content: ["전기기계·기구의 충전부", "충전부 접촉방지를 위한 폐쇄형 외함구조, 방호망 설치 및 충전부 격리 조치여부"],
        isChecked: "",
      },
      {
        content: ["전기기계·기구의 접지", "전기기계·기구의 금속제 외함 및 철대부분에 대한접지"],
        isChecked: "",
      },
      {
        content: ["누전차단기", "대지전압150V 초과하는 이동형전기기계기구 누전차단기 설치 및 과전류 보호장치의 적정사용 여부"],
        isChecked: "",
      },
      {
        content: ["배선 및 이동전선의 관리", "도전성이 높은 장소의 전기배선, 이동전선의 피복손상 방지조치 및 습윤장소의 방수형 꽂음접속기 사용 여부"],
        isChecked: "",
      },
      {
        content: ["안전작업 허가절차 준수", "화기작업, 산소결핍작업 등 위험 작업 시 안전작업허가서 발행 등 절차 준수상태"],
        isChecked: "",
      },
      {
        content: ["위험물의 저장·취급 안전", "위험물의 저장 시설 및 취급장소의 누출방지 및 화재폭발 예방 대책"],
        isChecked: "",
      },
      {
        content: ["소화설비의 관리", "소화설비의 설치 및 유지관리 상태"],
        isChecked: "",
      },
      {
        content: ["물질안전보건자료(MSDS) 관리", "화학 물질에 대한 물질안전보건자료(MSDS) 작성·비치 및 소분용기 경고표지 부착 여부"],
        isChecked: "",
      },
      {
        content: ["밀폐공간작업", "밀폐공간 프로그램 수립·시행, 작업허가서 발행, 안전보건교육 실시, 농도 측정, 적합한 장비 착용 여부"],
        isChecked: "",
      },
      {
        content: ["건강진단", "건강진단실시(일반·특수·배치전) 여부"],
        isChecked: "",
      },
      {
        content: ["작업환경측정", "작업환경측정 실시(반기 1회) 및 개선 조치 여부"],
        isChecked: "",
      },
      {
        content: ["근골격계질환 예방", "근골격계 유해요인조사 실시, 작업환경 개선 계획 및 개선 조치 여부"],
        isChecked: "",
      },
      {
        content: ["중량물 들기", "취급 물품의 중량과 무게중심 표시, 중량물의 제한, 작업조건, 작업자세 등 조치 여부"],
        isChecked: "",
      },
    ],
  },
];
